export default __webpack_public_path__ + "static/media/cpv_19_textile.85fa0b58.svg";